/** A collected-field key as a person reads it: "property_code" → "Property code". */
export function fieldLabel(key: string): string {
  const words = key.replace(/[_-]+/g, ' ').trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
